module.exports = __webpack_public_path__ + "img/setting-photo.0c32f18f.png";